import Box from '@/common/components/Box'
import Button from '@/common/components/Button'
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import GoBackButton from '@/common/components/GoBackButton'
import ResumeBox from '@/common/components/ResumeBox'
import { ModalDeleteEstablishmentTechnicalProfessional } from '@/features/maintenance/establishmentTechnicalProfessionals/components/modalDeleteEstablishmentTechnicalProfessional'
import { useEstablishmentTechnicalProfessional } from '@/features/maintenance/establishmentTechnicalProfessionals/hooks/useEstablishmentTechnicalProfessional'
import { ChevronsRightIcon } from 'lucide-react'
import { Link, useParams } from 'react-router-dom'

const Show = () => {
  const { id } = useParams()

  const {
    data: establishmentTechnicalProfessional,
    isPending: establishmentTechnicalProfessionalIsPending,
    error: establishmentTechnicalProfessionalError = {} as any,
    refetch: refetchPermission,
  } = useEstablishmentTechnicalProfessional(id || '')

  const disableUpdateButton =
    establishmentTechnicalProfessionalIsPending || establishmentTechnicalProfessionalError?.status === 403

  return (
    <div className="flex flex-col gap-y-6">
      <div className="flex justify-between items-center">
        <div className="flex gap-2 items-center">
          <GoBackButton fallback="/establishment-technical-professionals" searchLastRouteFromFallback />

          <p className="text-white-400 font-normal">Especialidade Técnica</p>

          <ChevronsRightIcon className="text-white-400" />

          <h2>{establishmentTechnicalProfessional?.display_name}</h2>
        </div>

        <div className="flex gap-4">
          <ModalDeleteEstablishmentTechnicalProfessional />

          <Link
            to={disableUpdateButton ? '' : `/establishment-technical-professionals/${id}/edit`}
            className={disableUpdateButton ? 'cursor-default' : ''}
          >
            <Button
              name="update_establishment_technical_professional"
              operationKlassToCheckPermission="Admin::Maintenance::EstablishmentTechnicalProfessionals::Update"
              disabled={disableUpdateButton}
            >
              Editar
            </Button>
          </Link>
        </div>
      </div>

      {establishmentTechnicalProfessionalIsPending ? (
        <Box>Carregando...</Box>
      ) : (
        <ErrorMessageWrapper
          className="h-[calc(100vh-128px)]"
          statusCode={establishmentTechnicalProfessionalError?.status}
          refetchFunction={refetchPermission}
        >
          <Box className="max-h-[calc(100vh-128px)] flex flex-col gap-4 overflow-y-auto">
            <p className="text-lg font-bold">Especialidade Técnica</p>

            <ResumeBox
              boxClassName="bg-white-200"
              label="Nome"
              value={establishmentTechnicalProfessional?.display_name || '--'}
              testId="display_name"
            />
          </Box>
        </ErrorMessageWrapper>
      )}
    </div>
  )
}

export default Show
